import { createAction, props } from '@ngrx/store';
import { GoParams } from '@shared/interfaces';

export const NavigateTo = createAction(
  '[Hub Navigation] Go the page',
  props<GoParams>()
);
